var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[_c('h4',{staticClass:"body-bold-base neutral-20-dark--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h5',{staticClass:"body-regular-smaller neutral-40-light--text"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }